<template>
  <div>
    <v-dialog v-model="areaDialog" max-width="1200" v-if="area">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between"
          >{{ area.name
          }}<v-btn color="white" icon @click="areaDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text>
          <v-overlay v-show="isLoading" opacity="1" color="white">
            <v-progress-circular
              :value="20"
              indeterminate
              color="green"
            ></v-progress-circular>
          </v-overlay>
          <v-tabs v-model="tab" color="primary" slider-color="primary">
            <v-tab ripple> {{ $t('contract.rental_contract') }} </v-tab>
            <v-tab ripple> {{ $t('customer.title') }} </v-tab>
            <v-tab ripple> {{ $t('checkout_title') }} </v-tab>
            <v-tab-item>
              <v-card flat>
                <v-card-text>cardText</v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <profile-detail></profile-detail>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text>cardText</v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn color="success" elevation="0" @click="areaDialog = false">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
          <v-btn color="error" elevation="0" @click="areaDialog = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProfileDetail from "./ProfileDetail.vue";
export default {
  components: { ProfileDetail },
  name: "PageName",
  computed: {
    areaDialog: {
      get() {
        if (this.value) {
          this.isLoading = true;
          this.$store
            .dispatch("customer/getCustomer", {
              id: this.area.contract.customer.objectId,
            })
            .then((data) => {
              this.isSuccess = true;
              this.isLoading = false;
            })
            .catch((err) => {
              this.isSuccess = true;
              this.isLoading = false;
            });
        }

        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {},
  data() {
    return {
      tab: 1,
      isLoading: false,
    };
  },
  props: {
    value: Boolean,
    area: Object,
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
